// extracted by mini-css-extract-plugin
export default {"offer":"Offer_offer__0jCb-"};